import React, { useEffect, useState, useRef } from "react";
import "../css2/HelprrGroundingOrb.css";

export default function HelprrGroundingOrb({
  mode = "grounding", // grounding | release | steady
  title = "Take a quiet pause",
  subtitle = "There’s nothing to do. Let your breath follow the movement.",
  durationLabel = "About 2 minutes",
  autoStart = true,
  soundSrc = "/assets/audio/helprr-soft-ambient.mp3",
}) {
  /* -----------------------------
     STATE
  ----------------------------- */

  // Controls orb animation
  const [isActive, setIsActive] = useState(autoStart);

  // Controls background sound
  const [soundOn, setSoundOn] = useState(false);

  const audioRef = useRef(null);

  /* -----------------------------
     EFFECTS
  ----------------------------- */

  // Keep orb animation in sync with autoStart
  useEffect(() => {
    setIsActive(autoStart);
  }, [autoStart]);

  // Handle audio playback safely
  useEffect(() => {
    if (!audioRef.current) return;

    if (soundOn) {
      audioRef.current.volume = 0.4;
      audioRef.current
        .play()
        .catch(() => {
          // autoplay blocked — user must interact first
        });
    } else {
      audioRef.current.pause();
    }
  }, [soundOn]);

  /* -----------------------------
     RENDER
  ----------------------------- */

  return (
    <section
      className={`helprr-orb-wrapper helprr-orb-wrapper--${mode}`}
      aria-label="Grounding exercise"
    >
      {/* Background audio (hidden) */}
      <audio ref={audioRef} loop src={soundSrc} />

      {/* Header */}
      <div className="helprr-orb-header">
        <h4>{title}</h4>
        <span className="helprr-orb-meta">{durationLabel}</span>
      </div>

      <p className="helprr-orb-subtitle">{subtitle}</p>

      {/* ORB */}
      <div
        className={`helprr-orb helprr-orb--${mode} ${
          isActive ? "active" : ""
        }`}
        aria-hidden="true"
      >
        <div className="helprr-orb-core" />
      </div>

      {/* CONTROLS */}
      <div className="helprr-orb-controls">
        {/* Play / Pause animation */}
        <button
          className="helprr-orb-btn"
          onClick={() => setIsActive(v => !v)}
        >
          {isActive ? "Pause" : "Play"}
        </button>

        {/* Sound toggle */}
        <button
          className="helprr-orb-btn secondary"
          onClick={() => setSoundOn(v => !v)}
        >
          {soundOn ? "Sound off" : "Sound on"}
        </button>
      </div>

      {/* Footnote */}
      <p className="helprr-orb-footnote">
        You can stop anytime. Even a few breaths count.
      </p>
    </section>
  );
}
